import PropTypes from 'prop-types';
import React, { Component } from 'react';
import BriefHeader from 'launch/components/BriefHeader';
import BriefStatus from 'launch/components/BriefStatus';
import Portal from 'launch/components/Portal';
import * as App from 'launch/components/AppContent';
import Viewport from 'common/utils/viewport';

class LaunchApp extends Component {
    constructor(props) {
        super(props);
    }

    getChildContext() {
        return {
            viewport: this.viewport
        };
    }

    componentWillMount() {
        this.viewport = new Viewport();
    }

    componentDidMount() {
        this.viewport.on('change', this.forceUpdate.bind(this));
    }

    componentWillUnmount() {
        this.viewport.removeAllListeners('change');
    }

    render() {
        return (
            <App.Content>
                <Portal portal='[data-status-container]'>
                    <BriefStatus />
                </Portal>
                <App.Header>
                    <BriefHeader  />
                </App.Header>
                <App.Body>
                    {this.props.children}
                </App.Body>
            </App.Content>
        );
    }
}

LaunchApp.propTypes = {
    brief: PropTypes.object,
};

LaunchApp.childContextTypes = {
    viewport: PropTypes.instanceOf(Viewport),
};

export default LaunchApp;



// WEBPACK FOOTER //
// ./js/launch/components/LaunchApp.jsx